import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { ChatService } from '../chat.service';
import { TipRainModalComponent } from '../tip-rain-modal/tip-rain-modal.component';
import { fadeInOut } from '@app/animations';
import { ModalService } from '@app/modal/modal.service';
import { environment } from '@env/environment';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { IconComponent } from '@shared/icon/icon.component';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-chat-rain',
  templateUrl: './chat-rain.component.html',
  styleUrls: ['./chat-rain.component.scss'],
  animations: [fadeInOut(300)],
  host: {
    '[class.trimmed]': 'isTrimmed()',
  },
  imports: [IconComponent, NgClass, CurrencyComponent],
})
export class ChatRainComponent {
  cdnBase = environment.cdnBase;

  constructor(public chatService: ChatService, private modalService: ModalService, private uiService: UIService) {}

  /** Tipping is only meaningful while the pool exists — states 1 and 2, matching tf2-hunt's widget. */
  canTip() {
    return this.chatService.rain.state !== 3;
  }

  /** Joining is only open during the claim window. */
  canJoin() {
    return this.chatService.rain.state === 2 && !this.chatService.rain.joined;
  }

  joinLabel() {
    if (this.chatService.rain.joined) {
      return 'Joined';
    }

    return this.chatService.rain.state === 2 ? 'Join Rain' : 'Rain Soon';
  }

  tipRainModal() {
    this.modalService.open(TipRainModalComponent);
  }

  isTrimmed() {
    return this.uiService.uiState().chat === 'trimmed';
  }
}
